import Konva from 'konva';
import { v4 as uuidv4 } from 'uuid';

import { Group } from 'konva/lib/Group';
import HaspObject from '../Hasp/HaspObject';
import { isHaspProperty } from '../Hasp/properties/v2/wireFormat.js';

/**
 * Object to show some onscreen object related menu.
 */
export default class ObjectMenu extends Group {
  node;
  dataGroup;
  valueObjects;
  objectDistance = 50;
  obj = 'object_menu';
  constructor(menu) {
    super(menu);
    this.visible(false);
  }

  isType() {
    return 'menu';
  }

  follow() {
    if (this.node) {
      this.visible(true);
      var pos = this.getStage().getAbsolutePos(this.node);
      pos.x += this.node.width() + this.objectDistance;
      this.position(pos);
      this.moveToTop();
    }
  }

  showData() {
    if (this.dataGroup !== undefined) this.dataGroup.destroy();
    this.dataGroup = new Konva.Group({
      x: 0,
      y: 0,
      width: this.width(),
      height: this.height(),
      draggable: true,
      selectable: true,
    });
    //menu background rect
    const rect = new Konva.Rect({
      id: uuidv4(),
      x: 0,
      y: 0,
      width: 200,
      height: 200,
      fill: '#1c176d',
      stroke: 'gray',
      strokeWidth: 2,
      draggable: true,
      name: 'object_menu',
      obj: 'object_menu',
      selectable: true,
      draggable: false,
      cornerRadius: 10,
      listening: true,
      opacity: 0.7,
    });
    this.dataGroup.add(rect);
    //seperator line
    this.dataGroup.add(
      new Konva.Line({
        points: [5, 20, rect.width() - 5, 20],
        stroke: '#8f8f8f',
        strokeWidth: 1,
        lineCap: 'round',
        lineJoin: 'round',
        obj: 'menu_line',
        lineCap: 'round',
      }),
    );
    //menu title text
    this.dataGroup.add(
      new Konva.Text({
        x: 10,
        y: 3,
        width: rect.width() - 10,
        text: this.node.obj,
        fontSize: 15,
        fontFamily: 'Calambri',
        fill: 'white',
        obj: 'menu_text',
        align: 'left',
      }),
    );
    this.valueObjects = {};
    var ypos = 15;
    this.node.properties.forEach((property, index) => {
      if (this.node.editorCapabilities?.has(property) || this.node.runtimeCapabilities?.has(property)) return;
      ypos += 13;
      var isColor = false;
      var val_property = property;
      if (isHaspProperty(this.node.schemaV2, property)) val_property = 'hasp_' + property;
      if (property === 'entityid') val_property = 'hass_entityid';

      //make value to a string
      var value = String(this.node[val_property]);
      if (typeof this.node[val_property] === 'function') value = this.node[val_property]();
      else if (property === 'parentid') value = this.node.parent.haspid;
      else if (typeof this.node[val_property] === 'object') value = JSON.stringify(this.node[val_property]);

      var colorValue = 'white';
      if (property.includes('color')) {
        isColor = true;
        colorValue = value;
        value = value; //'██ ' +
      }
      this.createPropertyObj(5, ypos, property);
      this.createValueObj(100, ypos, val_property, value);
      // color circle indicator
      if (isColor) {
        this.createColorObj(185, ypos + 5, val_property, colorValue);
      }
    });
    rect.height(ypos + 20);
    this.add(this.dataGroup);
  }

  createPropertyObj(x, y, property) {
    this.dataGroup.add(
      new Konva.Text({
        x: x,
        y: y, // Adjust spacing as needed
        text: property,
        fontSize: 10,
        fontFamily: 'Courier',
        fill: 'white',
        obj: 'menu_text',
        fontStyle: 'bold',
      }),
    );
  }

  createValueObj(x, y, val_property, value) {
    const valObject = new Konva.Text({
      x: x,
      y: y, // Adjust spacing as needed
      width: 80,
      text: value,
      fontSize: 10,
      fontFamily: 'Courier',
      fill: 'white',
      obj: 'menu_text',
      ellipsis: true,
      wrap: 'none',
    });
    this.valueObjects[val_property] = valObject;
    this.dataGroup.add(valObject);
  }

  createColorObj(x, y, val_property, colorValue) {
    const colorObj = new Konva.Circle({
      x: x,
      y: y,
      radius: 6,
      fill: colorValue,
      stroke: 'gray',
      strokeWidth: 1,
    })
    this.valueObjects[val_property + '_colobj'] = colorObj;
    this.dataGroup.add(colorObj);
  }

  setNode(node) {
    if (node) {
      this.visible(true);
      this.moveToTop();
      if (!this.isSameNode(node)) {
        this.node = node;
        this.showData();
      }
    } else {
      this.visible(false);
      this.node = undefined;
    }
  }

  isSameNode(node) {
    return node === this.node;
  }

  update(node) {
    if (this.node) {

      for (const property in this.valueObjects) {
        const valueObject = this.valueObjects[property];
        var value = '---';

        var colorValue = 'white';
        var fontStyle = 'normal';
        var isColor = false;

        if (typeof this.node[property] === 'function') {
          value = this.node[property]();
        } else if (property.endsWith('_colobj')) {
          const propString = property.slice(0, -7);
          colorValue = this.node[propString];
          isColor = true;
        } else if (property === 'parentid') {
          value = this.node.parent.haspid;
          if (value === undefined) value = '---';
        } else if (typeof value === 'number') {
          // Round the number to two decimals
          value = Number(value.toFixed(2))
        } else {
          value = this.node[property];
        }
        if (!isColor) {
          if (String(value) !== String(valueObject.text())) {
            colorValue = 'yellow';
            fontStyle = 'bold';
          }
          valueObject.text(value);
          valueObject.fontStyle(fontStyle);
        }
        valueObject.fill(colorValue)

      }
      this.follow();
    }
  }
  // Function to calculate absolute position recursively
  // getAbsolutePositionRecursive(node) {
  //   let absolutePosition = { x: 0, y: 0 };

  //   // Traverse parent hierarchy
  //   while (node !== undefined && node instanceof HaspObject) {
  //     absolutePosition.x += node.x();
  //     absolutePosition.y += node.y();
  //     node = node.getParent();
  //   }

  //   return absolutePosition;
  // }
}
